import { CountrySearchStatusEnum } from "./country-search-status-enum";
import { Evidence } from "./evidence";
import { EvidenceProvider } from "./evidence-provider";

export class Requirement {
    number: number;
    id: string;
    title: string;
    status: string;
    evidences: Evidence[];
    providers: EvidenceProvider[];
    haveProviders = false;
    selectedCountryCode: string;
    countrySearchStatus: CountrySearchStatusEnum | undefined;

    deleteEvidence(evidenceUUID: string): void {
        const evidenceToDelete = this.evidences.find(evidence => evidence.evidenceUUID === evidenceUUID);
        if (evidenceToDelete) {
            evidenceToDelete.status = "PENDING";
            evidenceToDelete.base64File = "";
            evidenceToDelete.mimeType = "";
            evidenceToDelete.fileName = "";
        }
    }
}
